module.exports = __webpack_public_path__ + "img/conhome-house-logo-fixed.d09a2f76.svg";